const constants = {
  API_URL_TENANT: '/tenant',
  API_URL_TENANT_BANNER: '/tenant/banner',
  API_URL_TENANT_CREATE: '/tenant/create',
  API_TENANT_URL: '/tenant/sendURL',

  API_URL_PRESIGNUP: '/auth/keys',
  API_URL_RESET: '/auth/reset',
  API_URL_CODE: '/auth/sendResetCode',
  API_URL_USER_DETAILS: '/user/details',

  API_URL_STAGE: '/stage',
  API_URL_PREDICT: '/model/predict',

  API_URL_ARTICLE: '/article',
  API_URL_CATEGORY: '/category',
  API_URL_FAQ: '/faq',
  API_URL_SR: '/servicerequests',
  API_URL_USER: '/user',
  API_URL: '/auth/',
  API_SIGNIN: '/signin',
  API_SIGNUP: '/signup',
  API_KEYS: '/keys',
  API_JWT: '/signin/jwt',

  API_JSON_FLATTEN: '/api/flatten',
  API_JSON_TO_CSV: '/api/csv',
};

export default constants;
